// extracted by mini-css-extract-plugin
export default {"eventBlock":"EventLogInfo_eventBlock__nIR8r","eventName":"EventLogInfo_eventName__+YC+C","eventTitle":"EventLogInfo_eventTitle__uH8iU","eventText":"EventLogInfo_eventText__f0T0Z"};